<template>
  <div class="new-project">

    <v-card>

    <v-toolbar color="transparent" flat>
      <v-toolbar-title>New Check</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-banner>
      Select a whole Google Ads account or a specific campaign to check for broken URLs. Best practice is to group by account if all nested campaigns belongs to the same website.
    </v-banner>

    <v-row>
      <v-col class="scroll-list">

        <LoadingIndicator v-if="loadingAccounts"
          text='Loading accounts from Google Ads' />

        <v-treeview
          ref="hierarchy"
          activatable
          open-on-click
          return-object
          :active.sync="activeAccounts"
          hoverable
          :items="clientAccounts"
        >
          <template v-slot:append="{ item, open }">
            {{ item.note }}
          </template>
        </v-treeview>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col class="pa-6 scroll-list" cols="6">

        <div
          v-if="activeAccounts.length === 0"
          key="title"
          class="title font-weight-light grey--text pa-4 text-center"
        >
          Select account to list campaigns
        </div>

        <LoadingIndicator v-if="loadingCampaings"
          text='Loading campaigns from Google Ads' />

        <v-treeview
          activatable
          hoverable
          return-object
          open-on-click
          item-disabled="paused"
          :active.sync="activeCampaigns"
          :items="campaigns"
          v-show="activeAccounts.length > 0"
        >
          <template v-slot:append="{ item, open }">
            {{ item.id }}
          </template>
        </v-treeview>

      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <v-btn
        class="white--text"
        color="primary"
        depressed
        @click="create"
      >
        Create project
      </v-btn>
    </v-card-actions>

    </v-card>

  </div>
</template>

<script>

import { fetchGoogleAdsClientAccounts,
  fetchGoogleCampaigns, createProject } from '@/api'

import LoadingIndicator from '@/components/LoadingIndicator'

export default {
  name: 'new-project',
  components: { LoadingIndicator },
  props: ['accountId'],
  data () {
    return {
      headers: [
        { text: '#', value: 'id' },
        { text: 'Name', value: 'name' },
      ],
      loadingAccounts: false,
      clientAccounts: [],
      activeAccounts: [],
      activeCampaigns: [],
      campaigns: [],
      loadingCampaings: false
    }
  },

  watch: {
    accountId: {
      immediate: true,
      handler: 'getClientAccounts'
    },
    activeAccounts: 'getCampaigns'
  },

  methods: {

    getClientAccounts () {
      this.loadingAccounts = true
      fetchGoogleAdsClientAccounts(this.accountId).then(data => {
        this.clientAccounts = data
        this.loadingAccounts = false
        this.$nextTick(() => {
          this.$refs.hierarchy.updateAll(true)
        })
      })
    },

    create () {

      if (this.activeAccounts.length != 1) {
        alert('You must select an account.')
        return
      }

      const accountItem = this.activeAccounts[0] || {}
      const campaignItem = this.activeCampaigns[0] || {}

      const descriptiveName = [accountItem.name, campaignItem.name].filter(x => x).join(" > ")

      createProject(this.accountId, {
        name: descriptiveName,
        google_ads_customer_id: accountItem.customer_id,
        google_ads_mcc_id: accountItem.mcc_id,
        google_ads_campaign_id: campaignItem.id
      }).then(() => {
        this.$router.push({ name: 'projects' })
      })

    },

    getCampaigns () {
      if (this.activeAccounts.length === 0) {
        return
      }
      this.loadingCampaings = true
      this.campaigns = []
      const item = this.activeAccounts[0]
      const mccId = item.mcc_id
      const customerId = item.customer_id
      fetchGoogleCampaigns(this.accountId, customerId, mccId).then(data => {
        this.campaigns = data
        this.loadingCampaings = false
      })
    }

  },
}

</script>

<style media="screen">
  .scroll-list {
    overflow-y: auto;
    max-height: 700px;
  }
</style>
